// extracted by mini-css-extract-plugin
export default {"socialLinks":"SocialLinks_socialLinks__TufF3","icon":"SocialLinks_icon__AVO04","otherIcons":"SocialLinks_otherIcons__hIFWj"};